/* Joffz V81. Collection-only UI and request scheduler. Product and cart code is untouched. */
(() => {
  if (window.__joffzCollectionV81 || !document.body.classList.contains('body-template-collection')) return;
  window.__joffzCollectionV81 = true;
  const desktop = matchMedia('(min-width: 750px)');
  const words = {
    en: ['Filter by', 'Close filters', 'Clear all', 'View results', 'Updating results…', 'Results could not be updated.', 'Try again'],
    de: ['Filtern nach', 'Filter schließen', 'Alle löschen', 'Ergebnisse anzeigen', 'Ergebnisse werden aktualisiert…', 'Ergebnisse konnten nicht aktualisiert werden.', 'Erneut versuchen'],
    fr: ['Filtrer par', 'Fermer les filtres', 'Tout effacer', 'Voir les résultats', 'Mise à jour des résultats…', 'Impossible de mettre à jour les résultats.', 'Réessayer'],
    es: ['Filtrar por', 'Cerrar filtros', 'Borrar todo', 'Ver resultados', 'Actualizando resultados…', 'No se pudieron actualizar los resultados.', 'Reintentar'],
    it: ['Filtra per', 'Chiudi filtri', 'Cancella tutto', 'Mostra risultati', 'Aggiornamento dei risultati…', 'Impossibile aggiornare i risultati.', 'Riprova'],
    tr: ['Filtrele', 'Filtreleri kapat', 'Tümünü temizle', 'Sonuçları göster', 'Sonuçlar güncelleniyor…', 'Sonuçlar güncellenemedi.', 'Tekrar dene']
  };
  const copy = words[(document.documentElement.lang || 'en').toLowerCase().split('-')[0]] || words.en;
  const state = { sequence: 0, controller: null, pending: null, applied: null, dirty: false, error: false, cache: new Map(), active: null, lastTrigger: null };
  const byId = id => document.getElementById(id);
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const normalize = value => {
    const params = new URLSearchParams(value || '');
    params.delete('section_id'); params.delete('sections');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) params.set('preview_theme_id', preview);
    return params.toString();
  };
  const serialize = form => {
    const params = new URLSearchParams();
    const forms = form?.id === 'FacetFiltersFormMobile' ? [form] : [...document.querySelectorAll('facet-filters-form form')].filter(node => ['FacetFiltersForm', 'FacetSortForm', 'FacetSortDrawerForm'].includes(node.id));
    for (const node of forms) for (const [key, value] of new FormData(node)) {
      if (key.startsWith('filter.')) { if (!params.getAll(key).includes(value)) params.append(key, value); }
      else params.set(key, value);
    }
    return normalize(params.toString());
  };
  function feedback(busy, error = false) {
    state.error = error;
    const grid = byId('ProductGridContainer');
    grid?.setAttribute('aria-busy', String(busy));
    grid?.querySelector('.collection')?.classList.toggle('loading', busy);
    ['ProductCount', 'ProductCountDesktop'].forEach(id => byId(id)?.classList.toggle('loading', busy));
    document.querySelectorAll('[data-joffz-drawer-v81]').forEach(form => {
      form.setAttribute('aria-busy', String(busy));
      setText(form.querySelector('[data-jf-status]'), error ? copy[5] : busy ? copy[4] : '');
      const retry = form.querySelector('[data-jf-retry]');
      if (retry) retry.hidden = !error;
      const apply = form.querySelector('[data-jf-apply]');
      if (apply) apply.disabled = busy && !state.dirty;
    });
    let message = byId('JoffzFilterErrorV81');
    if (error && !message && grid) {
      message = document.createElement('div'); message.id = 'JoffzFilterErrorV81'; message.setAttribute('role', 'alert');
      const text = document.createElement('span'); text.textContent = copy[5];
      const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = copy[6]; retry.dataset.jfRetry = '';
      message.append(text, retry); grid.before(message);
    }
    if (message) message.hidden = !error;
  }
  const close = (restore = true) => {
    const form = state.active;
    const details = form?.querySelector('.facets__horizontal-top details');
    if (details) details.open = false;
    form?.querySelector('.facets__wrapper')?.classList.remove('active');
    form?.querySelector('.facets-mask')?.classList.remove('active');
    form?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    const panel = form?.querySelector('.facets__container');
    if (restore && state.lastTrigger?.isConnected) state.lastTrigger.focus({ preventScroll: true });
    if (panel) { panel.inert = true; panel.setAttribute('aria-hidden', 'true'); }
    document.body.classList.remove('joffz-filter-drawer-open'); state.active = null;
  };
  const open = form => {
    if (!desktop.matches) return;
    if (state.active && state.active !== form) close(false);
    state.active = form;
    state.lastTrigger = form.querySelector('.facets__horizontal-top summary');
    const panel = form.querySelector('.facets__container');
    panel.inert = false; panel.setAttribute('aria-hidden', 'false');
    form.querySelector('.facets__horizontal-top details').open = true;
    state.lastTrigger.setAttribute('aria-expanded', 'true');
    form.querySelector('.facets__wrapper').classList.add('active');
    form.querySelector('.facets-mask').classList.add('active');
    document.body.classList.add('joffz-filter-drawer-open');
    panel.querySelector('[data-jf-close]').focus({ preventScroll: true });
  };
  function groups(form) {
    form.querySelectorAll('#FacetsWrapperDesktop > .js-filter').forEach((group, index) => {
      const heading = group.querySelector('.facets__disclosure-header');
      const title = heading?.querySelector('.subtitle');
      const display = group.querySelector('.facets__display');
      if (!title || !display) return;
      let toggle = title.querySelector('[data-jf-toggle]');
      if (!toggle) {
        const name = title.textContent.trim();
        toggle = document.createElement('button'); toggle.type = 'button'; toggle.dataset.jfToggle = '';
        const label = document.createElement('span'); label.textContent = name;
        const count = document.createElement('span'); count.className = 'jf-group-count'; count.dataset.jfCount = '';
        const arrow = document.createElement('span'); arrow.className = 'jf-chevron'; arrow.setAttribute('aria-hidden', 'true');
        toggle.append(label, count, arrow); title.replaceChildren(toggle);
      }
      const checked = group.querySelectorAll('input[type="checkbox"]:checked').length;
      const priceActive = [...group.querySelectorAll('input[type="number"][name]')].some(input => input.value !== '');
      const selected = checked + (priceActive ? 1 : 0);
      const count = toggle.querySelector('[data-jf-count]');
      setText(count, String(selected)); count.hidden = !selected;
      if (!group.dataset.jfExpanded) group.dataset.jfExpanded = String(index === 0 || selected > 0);
      const expanded = group.dataset.jfExpanded === 'true';
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-controls', display.id);
      display.hidden = !expanded;
      const reset = heading.querySelector('facet-remove'); if (reset) reset.hidden = !selected;
    });
    const count = byId('ProductCount');
    setText(form.querySelector('[data-jf-total]'), count?.textContent.trim() || '');
    const selected = form.querySelectorAll('input[type="checkbox"]:checked').length + [...form.querySelectorAll('input[type="number"][name]')].filter(node => node.value !== '').length;
    const clear = form.querySelector('[data-jf-clear]'); if (clear) clear.disabled = selected === 0;
  }
  const button = (attribute, text) => {
    const node = document.createElement('button'); node.type = 'button'; node.setAttribute(attribute, ''); node.textContent = text; return node;
  };
  function enhance() {
    if (state.active && !state.active.isConnected) close(false);
    if (!desktop.matches) return;
    const form = document.querySelector('.collection-grid-section #FacetFiltersForm');
    const panel = form?.querySelector('.facets__container');
    const details = form?.querySelector('.facets__horizontal-top details');
    if (!panel || !details) return;
    if (!form.hasAttribute('data-joffz-drawer-v81')) {
      form.dataset.joffzDrawerV81 = '';
      panel.id = 'JoffzFilterPanelV81'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-labelledby', 'JoffzFilterTitleV81'); panel.setAttribute('aria-hidden', 'true'); panel.inert = true;
      const summary = details.querySelector('summary'); summary.setAttribute('aria-controls', panel.id); summary.setAttribute('aria-expanded', 'false'); summary.setAttribute('aria-haspopup', 'dialog');
      const head = document.createElement('div'); head.className = 'joffz-filter-drawer__head';
      const block = document.createElement('div');
      const title = document.createElement('h2'); title.id = 'JoffzFilterTitleV81'; title.className = 'joffz-filter-drawer__title'; title.textContent = copy[0];
      const total = document.createElement('p'); total.dataset.jfTotal = '';
      block.append(title, total);
      const closeButton = button('data-jf-close', ''); closeButton.className = 'joffz-filter-drawer__close'; closeButton.setAttribute('aria-label', copy[1]);
      closeButton.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
      head.append(block, closeButton); panel.prepend(head);
      const foot = document.createElement('div'); foot.className = 'joffz-filter-drawer__foot';
      const status = document.createElement('p'); status.dataset.jfStatus = ''; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      const retry = button('data-jf-retry', copy[6]); retry.hidden = true;
      const row = document.createElement('div'); row.className = 'jf-actions'; row.append(button('data-jf-clear', copy[2]), button('data-jf-apply', copy[3]));
      foot.append(status, retry, row); panel.append(foot);
      form.addEventListener('click', event => {
        if (!desktop.matches || !(event.target instanceof Element)) return;
        const trigger = event.target.closest('.facets__horizontal-top summary');
        if (trigger && trigger === summary) {
          event.preventDefault(); event.stopImmediatePropagation();
          state.active === form ? close() : open(form); return;
        }
        if (event.target.closest('[data-jf-close]') || event.target.classList.contains('facets-mask')) {
          event.preventDefault(); event.stopImmediatePropagation(); close(); return;
        }
        const toggle = event.target.closest('[data-jf-toggle]');
        if (toggle) {
          event.preventDefault();
          const group = toggle.closest('.js-filter'); group.dataset.jfExpanded = String(group.dataset.jfExpanded !== 'true'); groups(form);
        }
      }, true);
      details.addEventListener('toggle', () => { if (!details.open && state.active === form) close(); });
    }
    groups(form);
  }
  function installScheduler(C) {
    if (C.__joffzV81) return;
    C.__joffzV81 = true;
    const originalSubmit = C.prototype.onSubmitHandler;
    C.prototype.onSubmitHandler = function(event) {
      if (!this.closest('.collection-grid-section')) return originalSubmit.call(this, event);
      event?.preventDefault?.();
      const form = event?.target?.closest?.('form') || this.querySelector('form');
      if (form?.isConnected) return C.renderPage(serialize(form), event);
    };
    function applyDocument(doc) {
      const sourceGrid = doc.getElementById('ProductGridContainer');
      const targetGrid = byId('ProductGridContainer');
      if (!sourceGrid || !targetGrid || !doc.getElementById('product-grid')) throw new Error('Invalid collection section');
      const focusId = document.activeElement?.id;
      const hadPanelFocus = state.active?.querySelector('.facets__container')?.contains(document.activeElement);
      const scrollTop = byId('FacetsWrapperDesktop')?.scrollTop || 0;
      ['FacetFiltersForm', 'FacetFiltersFormMobile', 'FacetFiltersPillsForm'].forEach(id => {
        const source = doc.getElementById(id), target = byId(id);
        if (!source || !target) return;
        source.querySelectorAll('.js-filter').forEach(group => {
          const current = [...target.querySelectorAll('.js-filter')].find(node => node.dataset.index === group.dataset.index);
          if (current) current.innerHTML = group.innerHTML;
        });
      });
      C.renderActiveFacets(doc);
      ['.mobile-facets__open', '.mobile-facets__count', '.sorting'].forEach(selector => {
        const source = doc.querySelector(selector), target = document.querySelector(selector);
        if (source && target) target.innerHTML = source.innerHTML;
      });
      byId('FacetFiltersFormMobile')?.closest('menu-drawer')?.bindEvents?.();
      targetGrid.innerHTML = sourceGrid.innerHTML;
      ['ProductCount', 'ProductCountDesktop'].forEach(id => {
        const target = byId(id), source = doc.getElementById(id) || doc.getElementById('ProductCount');
        if (source && target) target.innerHTML = source.innerHTML;
      });
      if (typeof window.loadMore === 'function' && targetGrid.querySelector('.js-load-more, .js-infinite-scroll')) window.loadMore();
      if (typeof window.colorSwatches === 'function') window.colorSwatches();
      enhance();
      if (byId('FacetsWrapperDesktop')) byId('FacetsWrapperDesktop').scrollTop = scrollTop;
      if (focusId && byId(focusId)) byId(focusId).focus({ preventScroll: true });
      else if (hadPanelFocus) state.active?.querySelector('[data-jf-close]')?.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('joffz:facets:updated', { detail: { sectionId: doc.getElementById('product-grid').dataset.id } }));
    }
    C.renderPage = function(searchParams, event, updateURLHash = true) {
      const params = normalize(searchParams);
      const sectionId = byId('product-grid')?.dataset.id;
      if (!sectionId) { feedback(false, true); return Promise.resolve(false); }
      const url = new URL(location.pathname, location.origin); url.search = params; url.searchParams.set('section_id', sectionId);
      const key = url.pathname + url.search;
      state.dirty = false;
      if (state.pending?.key === key) return state.pending.promise;
      if (state.applied === key && !state.error) { feedback(false); return Promise.resolve(true); }
      const sequence = ++state.sequence;
      state.controller?.abort(); state.controller = new AbortController();
      const controller = state.controller;
      C.searchParamsPrev = params;
      if (updateURLHash && normalize(location.search) !== params) C.updateURLHash(params);
      feedback(true);
      const task = (async () => {
        let timeout;
        try {
          const cached = state.cache.get(key);
          let html = cached && Date.now() - cached.at < 60000 ? cached.html : null;
          if (!html) {
            timeout = setTimeout(() => controller.abort(), 15000);
            const response = await fetch(key, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error('Collection HTTP ' + response.status);
            html = await response.text();
          }
          if (sequence !== state.sequence) return false;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          applyDocument(doc);
          state.cache.delete(key); state.cache.set(key, { html, at: Date.now() });
          while (state.cache.size > 8) state.cache.delete(state.cache.keys().next().value);
          state.applied = key; feedback(false); return true;
        } catch (error) {
          if (sequence === state.sequence) feedback(false, true);
          return false;
        } finally {
          clearTimeout(timeout);
          if (sequence === state.sequence) { state.controller = null; state.pending = null; }
        }
      })();
      state.pending = { key, promise: task };
      task.finally(() => { if (state.pending?.promise === task) state.pending = null; });
      return task;
    };
    document.addEventListener('input', event => {
      const form = event.target?.closest?.('.collection-grid-section facet-filters-form form');
      if (!form) return;
      state.sequence++; state.controller?.abort(); state.pending = null; state.dirty = true;
      feedback(true); if (form.id === 'FacetFiltersForm') groups(form);
    }, true);
    document.addEventListener('click', async event => {
      const action = event.target?.closest?.('[data-jf-clear], [data-jf-apply], [data-jf-retry]');
      if (!action) return;
      event.preventDefault();
      const form = action.closest('form') || byId(desktop.matches ? 'FacetFiltersForm' : 'FacetFiltersFormMobile');
      if (!form) return;
      let params = new URLSearchParams(serialize(form));
      if (action.hasAttribute('data-jf-clear')) {
        for (const key of [...params.keys()]) if (key.startsWith('filter.')) params.delete(key);
        form.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
        form.querySelectorAll('input[type="number"][name]').forEach(input => { input.value = ''; });
        groups(form);
      }
      const success = await C.renderPage(params.toString());
      if (success && action.hasAttribute('data-jf-apply')) close();
    });
  }
  document.addEventListener('keydown', event => {
    if (!state.active || !desktop.matches) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close(); return; }
    if (event.key !== 'Tab') return;
    const panel = state.active.querySelector('.facets__container');
    const nodes = [...panel.querySelectorAll('button, a[href], input, select, [tabindex]')].filter(node => !node.disabled && node.tabIndex >= 0 && node.getClientRects().length && !node.closest('[hidden]'));
    const first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
  }, true);
  desktop.addEventListener('change', () => { if (!desktop.matches) close(false); else enhance(); });
  customElements.whenDefined('facet-filters-form').then(() => installScheduler(customElements.get('facet-filters-form')));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true }); else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
